import { isEmpty, reduce } from 'lodash';
import {
  BATH,
  BATH_PER_SQM,
  MILLION_BATH,
} from '../../../common/helpers/constants';
import LocationHelper from '../../../common/helpers/domain/LocationHelper';
import projectResource from '../../../locales/th/project.json';

export function getGeneralDetailsConfig(
  propertyType,
  buildingProfile,
  coordinate,
  developer,
) {
  const buildingProfileToArray = reduce(
    buildingProfile,
    (result, attribute) => {
      result[attribute.label] = attribute.value;
      return result;
    },
    [],
  );

  const addHttp = (url) => {
    if (!/^(f|ht)tps?:\/\//i.test(url)) {
      url = 'http://' + url;
    }
    return url;
  };

  return [
    {
      label: projectResource.generalDetail.category + ':',
      value: propertyType,
      hasLink: true,
      link: '',
    },
    {
      label: projectResource.generalDetail.buildingInformation + ':',
      value: buildingProfileToArray.information
        ? buildingProfileToArray.information
        : '',
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.numberOfFloor + ':',
      value: buildingProfileToArray.num_floor
        ? buildingProfileToArray.num_floor
        : '',
    },
    {
      label: projectResource.generalDetail.numberOfUnit + ':',
      value: buildingProfileToArray.num_unit
        ? buildingProfileToArray.num_unit
        : '',
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.maxUnitFLoor + ':',
      value: buildingProfileToArray.max_unit_floor
        ? buildingProfileToArray.max_unit_floor
        : '',
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.landArea + ':',
      value:
        buildingProfileToArray.land_area &&
        buildingProfileToArray.land_area !== '0-0-0'
          ? buildingProfileToArray.land_area +
            ' ' +
            projectResource.generalDetail.acres
          : '',
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.coordinate + ':',
      value: LocationHelper.getCoordinate(coordinate),
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.telephoneNumber + ':',
      value: developer.phone,
      hasLink: false,
      link: '',
    },
    {
      label: projectResource.generalDetail.projectWebsite + ':',
      value: !isEmpty(developer.website_label)
        ? developer.website_label
        : developer.website,
      hasLink: true,
      link: addHttp(developer.website),
    },
  ];
}

const generateDisplayPrice = (priceTypes) => {
  if (!isEmpty(priceTypes.display_price)) {
    return priceTypes.display_price;
  } else if (!isEmpty(priceTypes.starting_price)) {
    return priceTypes.starting_price + ' ' + MILLION_BATH;
  } else {
    return '';
  }
};

export function getPriceInformationConfig(priceTypes) {
  return [
    {
      label: projectResource.priceInformation.startingPrice + ':',
      value: generateDisplayPrice(priceTypes),
    },
    {
      label: projectResource.priceInformation.perSquareMeter + ':',
      value:
        priceTypes.per_square_meter &&
        priceTypes.per_square_meter + ' ' + BATH_PER_SQM,
    },
    {
      label: projectResource.priceInformation.maintenanceFee + ':',
      value: priceTypes.maintenance_fee,
    },
    {
      label: projectResource.priceInformation.funds + ':',
      value: priceTypes.fund && priceTypes.fund + ' ' + BATH,
    },
    {
      label: projectResource.priceInformation.signFee + ':',
      value: priceTypes.signing_fee,
    },
  ];
}
